import { Injectable } from '@angular/core';
import pdfjsLib from '../../assets/pdfjs-config';
import {
  ConversionResponse,
  PageWithViewport,
} from '../sessions/session/pdf-canvas-item/pdf-services/pdf-manager.service';

@Injectable({
  providedIn: 'root',
})
export class PdfCacheService {
  private pdfContextMap = new Map<string, pdfjsLib.PDFDocumentProxy>();
  private pdfPageWithViewportCache = new Map<string, PageWithViewport>();
  private pdfConvertedImagesCache = new Map<string, ConversionResponse>();

  cachePDF(id: string, documentProxy: pdfjsLib.PDFDocumentProxy) {
    this.pdfContextMap.set(id, documentProxy);
  }

  removePDFFromCache(contentId: string) {
    delete this.pdfContextMap[contentId];
  }

  getPDFIfExists(contentId: string) {
    return this.pdfContextMap.get(contentId);
  }

  cachePage(contentId: string, pageNumber: number, pageWithViewport: PageWithViewport) {
    const pageHashKey = this.hashPageKey(contentId, pageNumber);
    return this.pdfPageWithViewportCache.set(pageHashKey, pageWithViewport);
  }

  cacheConvertedImages(contentId: string, conversionResponse: ConversionResponse) {
    this.pdfConvertedImagesCache.set(contentId, conversionResponse);
  }

  removePageFromCache(contentId: string, pageNumber: number) {
    const pageHashKey = this.hashPageKey(contentId, pageNumber);
    delete this.pdfPageWithViewportCache[pageHashKey];
  }

  getPageIfExists(contentId: string, pageNumber: number) {
    const pageHashKey = this.hashPageKey(contentId, pageNumber);
    return this.pdfPageWithViewportCache.get(pageHashKey);
  }

  getConvertedImagesIfExists(contentId: string) {
    return this.pdfConvertedImagesCache.get(contentId);
  }

  private hashPageKey(contentId: string, pageNumber: number) {
    return `<${contentId}|${pageNumber}>`;
  }

  clearCache() {
    this.pdfContextMap.clear();
    this.pdfPageWithViewportCache.clear();
    this.pdfConvertedImagesCache.clear();
  }
}
